//
// BuiltInStyles.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var BuiltInStyles = {
    NONE:0,
    DARK:1,
    DARK_2:2,
    HIGH_CONTRAST:3,
    HTML_ENCORE:4,
    LIGHT:5,
    MIDNIGHT:6,
    OPAL:7,
    RAVEN:8,
    RAVEN_2:9,
    UMSTEAD:10,
    LIGHT_2025:11,
    DARK_2025:12,
    HIGH_CONTRAST_2025:13,
    SPRING:14,
    STEEL:15,
    GRAYSCALE:16,
    MONOCHROME:17
};
export default BuiltInStyles;
